import { ManualAddressDto } from "@shared/src/controllers/maps/ManualAddressDto";

export class Route_eCMRAddressDTO {
	public id: number;
	public key: string;
	public name: string;
	public address: ManualAddressDto;
	public contactPhone: string;
	public reset: boolean;

	public static buildReset(): Route_eCMRAddressDTO {
		let result: Route_eCMRAddressDTO = new Route_eCMRAddressDTO();
		result.reset = true;
		return result;
	}

	public static build(addressId: number, key: string, name: string, address: ManualAddressDto, contactPhone: string): Route_eCMRAddressDTO {
		let result: Route_eCMRAddressDTO = new Route_eCMRAddressDTO();
		result.id = addressId;
		result.key = key;
		result.name = name;
		result.address = address;
		result.contactPhone = contactPhone;
		return result;
	}
}
